<template>
  <div class="fallible-set">
    <div class="fallible-set__describe">
      欢迎使用易错集，本次为您精心筛选了一些易错的题目，选择学科，点击“Go”开始练习吧！
    </div>
    <div class="fallible-set__wrapper">
      <img class="art-words art-words--1" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/652f3a467586f9e3246ef24c52eec0dd.png" alt="选学科">
      <!-- <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8f7f048c2a351d0f480f1de1e54dee7b.png" width="32" height="32"> -->
      <div class="subject-list">
        <div
          class="subject-list__item"
          :class="{'subject-list__item--active': currentSubjectCode === subject.code}"
          v-for="subject in subjectList"
          :key="subject.code"
          @click="onClick(subject)"
        >
          {{subject.name}}
        </div>
      </div>
      <!-- <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/da28805cc5363180164d9281f36dadf2.png" width="32" height="32"> -->
      <img class="art-words art-words--2" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ceda9d66b7d312efc3ce2d49240828b4.png" alt="选内容">
      <div class="practice-way">
        <div
          class="practice-way__item"
          :class="{'practice-way__item--active': practiceWay === 'system'}"
          @click="onOptionClick('system')"
        >
          系统推荐易错题
        </div>
        <div
          class="practice-way__item"
          :class="{'practice-way__item--active': practiceWay === 'user'}"
          @click="onOptionClick('user')"
        >
          仅练自己易错题
        </div>
      </div>
    </div>
    <div class="fallible-set__button" @click="onGo"></div>
  </div>
</template>

<script>
import api from '@/api/graphql/test';

export default {
  name: 'name',
  components: {},
  data() {
    return {
      subjectList: [],
      currentSubjectCode: '',
      practiceWay: 'system',
    };
  },
  computed: {},
  methods: {
    onClick(subject) {
      this.currentSubjectCode = subject.code;
    },
    onOptionClick(code) {
      this.practiceWay = code;
    },
    onGo() {
      if (!this.subjectList.length) return;
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          type: 'fallible',
          course: {
            projectCode: this.currentSubjectCode,
            type: {
              English: 'BKW',
              Chinese: 'YW',
            }[this.currentSubjectCode] || '',
          },
          projectCode: this.currentSubjectCode,
          action: this.practiceWay,
        },
      });
    },
  },
  mounted() {
    api
      .getProjectList()
      .then(({ projectList: subjectList }) => {
        this.subjectList = subjectList;
        if (subjectList.length) {
          const [defaultSubject] = subjectList;
          this.currentSubjectCode = defaultSubject.code;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
  .fallible-set {
    position: relative;
    display: flex;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    min-width: 1300px;
    min-height: 700px;
    background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/4d2e58067cb5f9c01c76ea8fd3285377.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &__describe {
      box-sizing: border-box;
      position: absolute;
      top: 15%;
      left: calc(50% - 765px / 2);
      width: 765px;
      height: 230px;
      line-height: 1.6;
      padding: 5%;
      color: #fff;
      font-size: 18px;
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/ad6b2f745b8805a94598a99ad22d666c.png');
      background-size: 100% 100%;
    }
    &__wrapper {
      position: absolute;
      left: 5%;
      right: 5%;
      bottom: 25%;
      height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: red;*/
    }
    &__button {
      position: absolute;
      bottom: 15.5%;
      left: calc(50% - 541px / 3.2);
      width: calc(514px / 1.6);
      height: calc(84px / 1.6);
      background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/e575aad0d065d2af7790f7b664f442fa.png');
      background-size: 100% 100%;
      cursor: pointer;
      &:active {
        transform: scale(.95);
      }
    }
    .art-words {
      width: calc(34px * .7);
      height: calc(140px * .7);
      &--1 {
        margin-right: 3%;
      }
      &--2 {
        margin: 0 3%;
      }
    }
    .practice-way {
      &__item {
        width: calc(384px * .65);
        height: calc(74px * .65);
        line-height: calc(74px * .65);
        text-align: center;
        color: #fff;
        font-size: 18px;
        background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/1c908b148ea87d8a46dbc03925d2466d.png');
        background-size: 100% 100%;
        cursor: pointer;
        &:first-child {
          margin-bottom: 12px;
        }
        &--active {
          background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/d173b4c3210ab8dfc8bddf63621090ab.png');
        }
      }
    }
    .subject-list {
      width: 600px;
      display: flex;
      flex-flow: wrap;
      /*background-color: red;*/
      &__item {
        width: calc(182px / 1.5);
        height: calc(66px / 1.5);
        line-height: calc(66px / 1.5);
        text-align: center;
        color: #fff;
        font-size: 20px;
        background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/47172218a9f4eb09d69398b95c4a7367.png');
        background-size: 100% 100%;
        margin: 20px 0 0 20px;
        cursor: pointer;
        &--active {
          background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/0d9fa85a13cfb9e8d8fa4689d69d2b84.png');
        }
      }
    }
  }
</style>
